if (!customElements.get('tooto-public-welfare')) {
  class TootoPublicWelfare extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.retryFrame = null;
      this.retryCount = 0;
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.initialize();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.destroy();
    }

    initialize() {
      if (this.swiper) return;

      const slider = this.querySelector('.tooto-public-welfare__slider');
      const slides = slider?.querySelectorAll('.swiper-wrapper > .tooto-public-welfare__project');

      if (!slider || !slides?.length) return;

      if (typeof window.Swiper !== 'function') {
        if (this.retryCount < 180) {
          this.retryCount += 1;
          this.retryFrame = requestAnimationFrame(() => this.initialize());
        }
        return;
      }

      this.retryCount = 0;
      this.retryFrame = null;

      this.swiper = new window.Swiper(slider, {
        loop: true,
        slidesPerView: 1.18,
        centeredSlides: true,
        loopedSlides: 3,
        loopAdditionalSlides: 3,
        speed: 600,
        spaceBetween: Number(this.dataset.gapMobile) || 0,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          enabled: true,
        },
        observer: true,
        observeParents: true,
        watchOverflow: true,
        breakpoints: {
          990: {
            slidesPerView: 2,
            centeredSlides: false,
            spaceBetween: Number(this.dataset.gap) || 0,
          },
        },
      });
    }

    destroy() {
      if (this.retryFrame) {
        cancelAnimationFrame(this.retryFrame);
        this.retryFrame = null;
      }

      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.destroy(true, true);
      }

      this.swiper = null;
      this.retryCount = 0;
    }

    handleBlockSelect(event) {
      const selectedItem = event.target.closest?.('.tooto-public-welfare__project');
      if (!selectedItem || !this.contains(selectedItem) || !this.swiper) return;

      const slides = Array.from(
        this.querySelectorAll('.swiper-wrapper > .tooto-public-welfare__project')
      );
      const slideIndex = slides.indexOf(selectedItem);

      if (slideIndex < 0) return;

      if (typeof this.swiper.slideToLoop === 'function') {
        this.swiper.slideToLoop(slideIndex, 300);
      } else {
        this.swiper.slideTo(slideIndex, 300);
      }
    }
  }

  customElements.define('tooto-public-welfare', TootoPublicWelfare);
}
